<div class="page-header">
  <h1>
    Utilisateurs
    @if (archives) {
    <span class="page-header-sub">archivés / bloqués</span>
    }
    <span class="page-header-count">({{ totalItems }})</span>
  </h1>
</div>

<div class="page-body">
  @if (duplicates?.length > 0) {
  <div class="alert alert-warning">
    <em class="fal fa-exclamation-triangle"></em>
    <div>
      <p class="alert-title">NIP dupliqué !</p>
      @for (u of duplicates; track u) {
      <p>{{ u.fullname }}@if (u.blocked) { <span>(Archivé)</span> } — Nip: {{ u.nip }}</p>
      }
      <p>Veuillez modifier le NIP.</p>
    </div>
  </div>
  }

  <div class="toolbar">
    <div class="search-box">
      <em class="fal fa-search"></em>
      <input
        #search
        (input)="searchInput.next(search.value)"
        (keyup.enter)="filterByLastname(search.value)"
        type="text"
        placeholder="Nom de famille, courriel, nip"
      />
    </div>

    <div class="toolbar-pagination">
      <pagination
        (numPages)="smallnumPages = $event"
        (pageChanged)="pageChanged($event)"
        [(ngModel)]="currentPage"
        [directionLinks]="true"
        [itemsPerPage]="30"
        [maxSize]="5"
        [totalItems]="totalItems"
        nextText="Suivant"
        previousText="Précédent"
      >
      </pagination>
    </div>

    <div class="toolbar-actions">
      <button
        type="button"
        class="btn btn-light btn-icon"
        tooltip="Ajouter un utilisateur"
        (cancel)="nothing()"
        (confirm)="createUser($event)"
        [swal]="{
          title: 'Ajouter un utilisateur',
          icon: 'info',
          text: 'NIP de la personne',
          input: 'text',
          showCancelButton: true,
          cancelButtonText: 'Annuler',
          confirmButtonText: 'Ajouter',
          animation: false
        }"
      >
        <em class="fal fa-plus"></em>
      </button>
      <button
        type="button"
        class="btn btn-light btn-icon"
        [class.icon-btn-active]="archives"
        tooltip="Voir les archives"
        (click)="toggleArchives()"
      >
        <em class="far fa-archive"></em>
      </button>
      @if (loggedUser.isRoot()) {
      <button
        type="button"
        class="btn btn-outline-warning btn-icon"
        tooltip="Import des utilisateurs"
        (cancel)="nothing()"
        (confirm)="importEcawin()"
        [swal]="{
          icon: 'warning',
          title: 'Mise à jour des utilisateurs.',
          text: 'Cette action ne peut pas être annulée.',
          showCancelButton: true,
          cancelButtonText: 'Annuler',
          confirmButtonText: 'Oui, je veux importer'
        }"
      >
        <em class="far fa-file-import"></em>
      </button>
      }
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover users-table">
      <thead>
        <tr>
          <th class="sortable" (click)="sortBy('lastname')">
            Nom
            @if (sortColumn == 'lastname') {
            <em class="fal" [ngClass]="sortDirection == 'ASC' ? 'fa-sort-up' : 'fa-sort-down'"></em>
            }
          </th>
          <th class="sortable" (click)="sortBy('firstname')">
            Prénom
            @if (sortColumn == 'firstname') {
            <em class="fal" [ngClass]="sortDirection == 'ASC' ? 'fa-sort-up' : 'fa-sort-down'"></em>
            }
          </th>
          <th class="sortable" (click)="sortBy('rank')">
            Grade
            @if (sortColumn == 'rank') {
            <em class="fal" [ngClass]="sortDirection == 'ASC' ? 'fa-sort-up' : 'fa-sort-down'"></em>
            }
          </th>
          <th>Courriel</th>
          <th class="sortable" (click)="sortBy('site.name')">
            OI
            @if (sortColumn == 'site.name') {
            <em class="fal" [ngClass]="sortDirection == 'ASC' ? 'fa-sort-up' : 'fa-sort-down'"></em>
            }
          </th>
          <th>Nip</th>
          <th>Num. Perso.</th>
          <th class="sortable" (click)="sortBy('lastConnection')">
            Dernière connexion
            @if (sortColumn == 'lastConnection') {
            <em class="fal" [ngClass]="sortDirection == 'ASC' ? 'fa-sort-up' : 'fa-sort-down'"></em>
            }
          </th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (user of users; track user) {
        <tr [class.row-blocked]="user.status === 'BLOCKED'">
          @if (editRow == user) {
          <td><input [(ngModel)]="user.lastname" class="form-control" type="text" /></td>
          <td><input [(ngModel)]="user.firstname" class="form-control" type="text" /></td>
          <td><input [(ngModel)]="user.rank" class="form-control" type="text" /></td>
          <td><input [(ngModel)]="user.username" class="form-control" type="text" /></td>
          <td>
            <select [(ngModel)]="user.site" [compareWith]="compareSitesById" class="form-select">
              @for (site of sites; track site) {
              <option [ngValue]="site">{{ site.name }}</option>
              }
            </select>
          </td>
          <td><input [(ngModel)]="user.nip" class="form-control" type="text" /></td>
          <td><input [(ngModel)]="user.personalNumber" class="form-control" type="text" /></td>
          <td>{{ user.lastConnection }}</td>
          <td>
            <div class="row-actions">
              <button (click)="save(user)" class="btn btn-light btn-icon" tooltip="Enregistrer" type="button">
                <em class="far fa-save"></em>
              </button>
              <button (click)="cancel()" class="btn btn-light btn-icon" tooltip="Annuler" type="button">
                <em class="far fa-ban"></em>
              </button>
            </div>
          </td>
          } @else {
          <td>{{ user.lastname }}</td>
          <td>{{ user.firstname }}</td>
          <td>{{ user.rank }}</td>
          <td>{{ user.username }}</td>
          <td>{{ user.site?.name }}</td>
          <td>{{ user.nip }}</td>
          <td>{{ user.personalNumber }}</td>
          <td>
            {{ user.lastConnection | date : 'd MMM yyyy' }}
            @if (user.lastConnection) {
            <span class="row-meta">({{ user.lastConnection | amLocale : 'fr' | amTimeAgo }})</span>
            }
          </td>
          <td>
            <div class="row-actions">
              @if (loggedUser.isAuthorized('OP_USERS_MANAGEMENT')) {
              <button
                type="button"
                class="btn btn-light btn-icon"
                tooltip="Changer le mot de passe"
                (cancel)="nothing()"
                (confirm)="updatePassword(user, $event)"
                [swal]="{
                  showCancelButton: true,
                  icon: 'info',
                  input: 'password',
                  text: 'Le mot de passe ne sera pas synchronisé avec l\'ECA',
                  title: 'Forcer un mot de passe local'
                }"
              >
                <em class="fal fa-key"></em>
              </button>
              <button
                type="button"
                [class.btn-outline-danger]="!user.ldap"
                class="btn btn-sm btn-light"
                tooltip="Activer/désactiver LDAP"
                (click)="togglLdap(user)"
              >
                Connexion ECA
                @if (!user.ldap) {
                <em class="fal fa-ban"></em>
                }
              </button>
              <button [routerLink]="['../permissions', user.id]" class="btn btn-sm btn-light" tooltip="Voir les permissions de cet utilisateur" type="button">
                Rôles
              </button>
              }
              @if (loggedUser.isAuthorized('OP_IMPERSONATE')) {
              <button
                type="button"
                class="btn btn-light btn-icon"
                tooltip="Se connecter en tant que cet utilisateur"
                [disabled]="user.isAuthorized('ROLE_ROOT')"
                (click)="impersonate(user)"
              >
                <em class="far fa-eye"></em>
              </button>
              }
              <button
                type="button"
                class="btn btn-light btn-icon"
                tooltip="Editer cet utilisateur"
                [disabled]="user.isAuthorized('ROLE_ROOT')"
                (click)="edit(user)"
              >
                <em class="fas fa-edit"></em>
              </button>
              @if (loggedUser.isAuthorized('OP_MESSAGES_ADMIN')) {
              <button [routerLink]="['/tags', user.id]" class="btn btn-light btn-icon" tooltip="Voir les tags pour cet utilisateur" type="button">
                <em class="far fa-tag"></em>
              </button>
              }
              @if (!user.blocked) {
              <button
                type="button"
                class="btn btn-light btn-icon"
                tooltip="Bloquer cet utilisateur"
                [disabled]="user.isAuthorized('ROLE_ROOT')"
                (click)="lock(user)"
              >
                <em class="far fa-unlock"></em>
              </button>
              } @else {
              <button
                type="button"
                class="btn btn-outline-warning btn-icon"
                tooltip="Débloquer cet utilisateur"
                [disabled]="user.isAuthorized('ROLE_ROOT')"
                (click)="unlock(user)"
              >
                <em class="far fa-lock"></em>
              </button>
              }
            </div>
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
